import { ApiBase } from "api/api";
import { makeGetRequest } from "api/fetchCalls";

import { SelectOptionModel } from "@/domain/model/select";

export const loadCustomerFieldsTypes = async (): Promise<
  SelectOptionModel[]
> => {
  const response = await makeGetRequest(ApiBase + "/customer_fields/types");
  return (response as Array<string[]>)?.map((type) => ({
    label: type?.[1],
    value: type?.[0],
  }));
};
